import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm, useWatch } from "react-hook-form";
import { FaArrowLeft } from "react-icons/fa";
import { Button } from "../../../components/ui";
import apiService from "../../../services/apiService";
import Loader from "../../../components/ui/Loader";
import {
  Select,
  Option,
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { useToast } from "../../../context/ToastContext";
import useAuthStore from "../../../store/authStore";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const AddQSet = () => {
  const navigate = useNavigate();

  const {
    control,
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: "",
      alias: "",
      course: "",
      stream: "",
      questions: "",
      marks: "",
      duration: "",
      taskId: "",
      subject: "",
      faculty: "",
    },
  });

  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [streams, setStreams] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [subjectLoading, setSubjectLoading] = useState(false);
  const [facultyLoading, setFacultyLoading] = useState(false);
  const [taskLoading, setTaskLoading] = useState(false);

  const [open, setOpen] = useState(0);

  const { showSuccess, showError } = useToast();
  const { user } = useAuthStore();

  const loginUser = user?.user || user?.data?.user || user?.data || user || {};

  const loginUserId =
    loginUser?.localUser?.id ||
    loginUser?.localUser?._id ||
    loginUser?.localUserId ||
    loginUser?.id ||
    loginUser?._id ||
    loginUser?.userId;

  const loginUserType = String(
    loginUser?.type || loginUser?.userType || loginUser?.role || "",
  ).toUpperCase();

  const isStaffUser = loginUserType === "STAFF";

  const selectedCourse = useWatch({
    control,
    name: "course",
  });

  const selectedStream = useWatch({
    control,
    name: "stream",
  });

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  const getArray = (result) => {
    if (Array.isArray(result)) return result;
    if (Array.isArray(result?.data)) return result.data;
    if (Array.isArray(result?.result)) return result.result;
    if (Array.isArray(result?.records)) return result.records;
    return [];
  };

  const getTaskName = (task) => {
    return (
      task?.title ||
      task?.name ||
      task?.value ||
      task?.taskId?.title ||
      task?.taskId?.name ||
      task?.templete?.title ||
      task?.templete?.name ||
      task?.template?.title ||
      task?.template?.name ||
      task?.subject?.name ||
      "Task"
    );
  };

  async function handleSubmitCustom(data) {
    setLoading(true);

    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("alias", data.alias);
    formData.append("course", data.course);
    formData.append("stream", data.stream);
    formData.append("totalQuestions", data.questions);
    formData.append("totalMarks", data.marks);
    formData.append("duration", data.duration);
    formData.append("task", data.taskId);

    const finalFacultyId = isStaffUser ? loginUserId : data.faculty;

    if (isStaffUser && !finalFacultyId) {
      setLoading(false);
      showError("Login user id not found");
      return;
    }

    if (finalFacultyId) {
      formData.append("faculty", finalFacultyId);
    }

    if (data.subject) {
      formData.append("subject", data.subject);
    }

    const obj = {
      quesStatus: "Not Uploaded",
      solStatus: "Not Uploaded",
    };

    formData.append("aiObj", JSON.stringify(obj));

    try {
      const rp = await apiService.request("/i/ims/aiqset", {
        method: "POST",
        body: formData,
      });

      console.log(rp);

      setLoading(false);
      reset();
      setSubjects([]);
      setFaculty([]);

      showSuccess("QSet created!!");
    } catch (err) {
      setLoading(false);
      console.log(err);
      showError("Request failed");
    }
  }

  useEffect(() => {
    const courseQuery = new URLSearchParams({
      option: "COURSE",
      limit: "all",
      sort: "seq ASC",
      status: true,
    }).toString();

    const streamQuery = new URLSearchParams({
      option: "STREAM",
      limit: "all",
      sort: "seq ASC",
      status: true,
    }).toString();

    apiService
      .request_old(`/i/admin/coption?${courseQuery}`, {
        method: "GET",
      })
      .then((result) => {
        setCourses(getArray(result));
      })
      .catch((err) => {
        console.log(err);
        setCourses([]);
      });

    apiService
      .request_old(`/i/admin/coption?${streamQuery}`, {
        method: "GET",
      })
      .then((result) => {
        setStreams(getArray(result));
      })
      .catch((err) => {
        console.log(err);
        setStreams([]);
      });
  }, []);

  useEffect(() => {
    let isActive = true;

    const params = new URLSearchParams({
      page: "1",
      limit: "all",
      totalCount: "true",
      populateTemplate: "true",
      // status: true,
    });

    setTaskLoading(true);

    apiService
      .request_old(`/i/ims/taskquestion?${params.toString()}`, {
        method: "GET",
      })
      .then((result) => {
        if (!isActive) return;
        setTasks(getArray(result));
      })
      .catch((err) => {
        if (!isActive) return;
        console.log(err);
        setTasks([]);
      })
      .finally(() => {
        if (!isActive) return;
        setTaskLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, []);

  useEffect(() => {
    let isActive = true;

    setFaculty([]);

    if (isStaffUser) {
      setValue("faculty", loginUserId || "");
      setFacultyLoading(false);

      return () => {
        isActive = false;
      };
    }

    setValue("faculty", "");

    const params = new URLSearchParams();

    if (selectedCourse) {
      params.append("course", selectedCourse);
    }

    params.append("limit", "all");
    params.append("status", "true");

    const facultyUrl = `/i/admin/faculty?${params.toString()}`;

    setFacultyLoading(true);

    apiService
      .request_old(facultyUrl, {
        method: "GET",
      })
      .then((result) => {
        if (!isActive) return;
        setFaculty(getArray(result));
      })
      .catch((err) => {
        if (!isActive) return;
        console.log(err);
        setFaculty([]);
      })
      .finally(() => {
        if (!isActive) return;
        setFacultyLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [selectedCourse, setValue, isStaffUser, loginUserId]);

  useEffect(() => {
    let isActive = true;

    setSubjects([]);
    setValue("subject", "");

    const params = new URLSearchParams();

    if (selectedCourse) {
      params.append("course", selectedCourse);
    }

    if (selectedStream) {
      params.append("stream", selectedStream);
    }

    params.append("limit", "all");
    params.append("status", "true");

    const queryString = params.toString();

    const subjectUrl = queryString
      ? `/i/ims/subject?${queryString}`
      : `/i/ims/subject`;

    setSubjectLoading(true);

    apiService
      .request_old(subjectUrl, {
        method: "GET",
      })
      .then((result) => {
        if (!isActive) return;
        setSubjects(getArray(result));
      })
      .catch((err) => {
        if (!isActive) return;
        console.log(err);
        setSubjects([]);
      })
      .finally(() => {
        if (!isActive) return;
        setSubjectLoading(false);
      });

    return () => {
      isActive = false;
    };
  }, [selectedCourse, selectedStream, setValue]);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Add New Question Set</h1>

        <Button
          onClick={() => navigate("/tools/qSet")}
          variant="light"
          size="sm"
          icon={FaArrowLeft}
        >
          Back to List
        </Button>
      </div>

      <div className="flex items-center text-sm mb-6">
        <span className="text-gray-500">Home</span>
        <span className="mx-2">/</span>
        <span onClick={() => navigate("/tools/qSet")} className="text-gray-500">
          QSet
        </span>
        <span className="mx-2">/</span>
        <span className="text-blue-600">New</span>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-visible mb-6 relative z-10">
        <div className="p-2 overflow-visible">
          <div>
            <form onSubmit={handleSubmit(handleSubmitCustom)}>
              <div className="flex flex-col justify-around overflow-visible">
                <div className="flex ml-5 mr-5">
                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Title <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      placeholder="Title of qSet"
                      className="w-full border rounded px-3 py-2"
                      {...register("title", { required: "Title is required" })}
                    />

                    {errors.title && (
                      <p className="text-red-500 text-sm">
                        {errors.title.message}
                      </p>
                    )}
                  </div>

                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Alias <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="text"
                      placeholder="Title Alias of qSet"
                      className="w-full border rounded px-3 py-2"
                      {...register("alias", { required: "Alias is required" })}
                    />

                    {errors.alias && (
                      <p className="text-red-500 text-sm">
                        {errors.alias.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex ml-5 mr-5">
                  <div className="p-3 w-1/2 overflow-visible">
                    <label className="block text-gray-700 mb-2">
                      Course <span className="text-red-500">*</span>
                    </label>

                    <Controller
                      name="course"
                      control={control}
                      rules={{ required: "Course is required" }}
                      render={({ field }) => (
                        <Select
                          key={field.value || "course"}
                          variant="outlined"
                          label="Select Course"
                          value={field.value || ""}
                          onChange={(val) => {
                            field.onChange(val || "");
                          }}
                          className="z-[9999]"
                          menuProps={{
                            className: "z-[9999] max-h-60 overflow-auto",
                          }}
                        >
                          {courses?.map((course, i) => (
                            <Option
                              key={course.id || course._id || i}
                              value={course.id || course._id}
                            >
                              {course.value || course.name || course.title}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />

                    {errors.course && (
                      <p className="text-red-500 text-sm">
                        {errors.course.message}
                      </p>
                    )}
                  </div>

                  <div className="p-3 w-1/2 overflow-visible">
                    <label className="block text-gray-700 mb-2">
                      Stream <span className="text-red-500">*</span>
                    </label>

                    <Controller
                      name="stream"
                      control={control}
                      rules={{ required: "Stream is required" }}
                      render={({ field }) => (
                        <Select
                          key={field.value || "stream"}
                          variant="outlined"
                          label="Select Stream"
                          value={field.value || ""}
                          onChange={(val) => {
                            field.onChange(val || "");
                          }}
                          className="z-[9999]"
                          menuProps={{
                            className: "z-[9999] max-h-60 overflow-auto",
                          }}
                        >
                          {streams?.map((stream, i) => (
                            <Option
                              key={stream.id || stream._id || i}
                              value={stream.id || stream._id}
                            >
                              {stream.value || stream.name || stream.title}
                            </Option>
                          ))}
                        </Select>
                      )}
                    />

                    {errors.stream && (
                      <p className="text-red-500 text-sm">
                        {errors.stream.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex ml-5 mr-5">
                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Total Questions <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="number"
                      placeholder="Total Questions"
                      className="w-full border rounded px-3 py-2"
                      {...register("questions", {
                        required: "Total Questions is required",
                      })}
                    />

                    {errors.questions && (
                      <p className="text-red-500 text-sm">
                        {errors.questions.message}
                      </p>
                    )}
                  </div>

                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Total Marks <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="number"
                      placeholder="Total Marks"
                      className="w-full border rounded px-3 py-2"
                      {...register("marks", {
                        required: "Total Marks is required",
                      })}
                    />

                    {errors.marks && (
                      <p className="text-red-500 text-sm">
                        {errors.marks.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex ml-5 mr-5">
                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Duration (in mins) <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="number"
                      placeholder="Enter Duration in mins"
                      className="w-full border rounded px-3 py-2"
                      {...register("duration", {
                        required: "Duration is required",
                      })}
                    />

                    {errors.duration && (
                      <p className="text-red-500 text-sm">
                        {errors.duration.message}
                      </p>
                    )}
                  </div>

                  <div className="p-3 w-1/2">
                    <label className="block text-gray-700 mb-2">
                      Task <span className="text-red-500">*</span>
                    </label>

                    <Controller
                      name="taskId"
                      control={control}
                      rules={{ required: "Task is required" }}
                      render={({ field }) => (
                        <select
                          value={field.value || ""}
                          disabled={taskLoading}
                          onChange={(e) => field.onChange(e.target.value || "")}
                          className="w-full border border-blue-gray-200 rounded-md px-3 py-2 text-gray-700 outline-none focus:border-gray-900 bg-white disabled:bg-gray-100"
                        >
                          <option value="">
                            {taskLoading ? "Loading Task..." : "Select Task"}
                          </option>

                          {tasks?.map((task, i) => (
                            <option
                              key={task.id || task._id || i}
                              value={task.id || task._id}
                            >
                              {getTaskName(task)}
                            </option>
                          ))}
                        </select>
                      )}
                    />

                    {errors.taskId && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.taskId.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="ml-5 mr-10 p-3">
                  <Accordion
                    open={open === 1}
                    icon={<Icon id={1} open={open} />}
                  >
                    <AccordionHeader onClick={() => handleOpen(1)}>
                      Advance Settings
                    </AccordionHeader>

                    <AccordionBody>
                      <div className="flex ml-5 mr-5">
                        <div
                          className={`p-3 ${isStaffUser ? "w-full" : "w-1/2"}`}
                        >
                          <label className="block text-gray-700 mb-2">
                            Subject
                          </label>

                          <Controller
                            name="subject"
                            control={control}
                            render={({ field }) => (
                              <select
                                value={field.value || ""}
                                disabled={!selectedCourse || subjectLoading}
                                onChange={(e) =>
                                  field.onChange(e.target.value || "")
                                }
                                className="w-full border border-blue-gray-200 rounded-md px-3 py-2 text-gray-700 outline-none focus:border-gray-900 bg-white disabled:bg-gray-100"
                              >
                                <option value="">
                                  {subjectLoading
                                    ? "Loading Subject..."
                                    : "Select Subject"}
                                </option>

                                {subjects?.map((subject, i) => (
                                  <option
                                    key={subject.id || subject._id || i}
                                    value={subject.id || subject._id}
                                  >
                                    {subject.name ||
                                      subject.value ||
                                      subject.title}
                                  </option>
                                ))}
                              </select>
                            )}
                          />

                          {errors.subject && (
                            <p className="text-red-500 text-sm mt-1">
                              {errors.subject.message}
                            </p>
                          )}
                        </div>

                        {!isStaffUser && (
                          <div className="p-3 w-1/2">
                            <label className="block text-gray-700 mb-2">
                              Faculty
                            </label>

                            <Controller
                              name="faculty"
                              control={control}
                              render={({ field }) => (
                                <select
                                  value={field.value || ""}
                                  disabled={facultyLoading}
                                  onChange={(e) =>
                                    field.onChange(e.target.value || "")
                                  }
                                  className="w-full border border-blue-gray-200 rounded-md px-3 py-2 text-gray-700 outline-none focus:border-gray-900 bg-white disabled:bg-gray-100"
                                >
                                  <option value="">
                                    {facultyLoading
                                      ? "Loading Faculty..."
                                      : "Select Faculty"}
                                  </option>

                                  {faculty?.map((item, i) => (
                                    <option
                                      key={item.id || item._id || i}
                                      value={item.id || item._id}
                                    >
                                      {item.name || item.value || item.title}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />

                            {errors.faculty && (
                              <p className="text-red-500 text-sm mt-1">
                                {errors.faculty.message}
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </AccordionBody>
                  </Accordion>
                </div>

                <div className="p-3">
                  <button
                    type="submit"
                    disabled={loading}
                    className="bg-green-500 font-thin text-white p-2 rounded hover:bg-green-600 m-2 disabled:opacity-60"
                  >
                    Submit
                  </button>

                  {loading && <Loader />}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="mt-6 bg-gray-50 border rounded-lg p-4">
        <h3 className="font-semibold mb-2">Instructions:</h3>

        <ul className="list-disc pl-5">
          <li>
            Fields marked with <span className="text-red-500">*</span> are
            mandatory.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AddQSet;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Controller, useForm, useWatch } from "react-hook-form";
// import { FaArrowLeft } from "react-icons/fa";
// import { Button } from "../../../components/ui";
// import apiService from "../../../services/apiService";
// import Loader from "../../../components/ui/Loader";
// import {
//   Select,
//   Option,
//   Accordion,
//   AccordionHeader,
//   AccordionBody,
// } from "@material-tailwind/react";
// import { useToast } from "../../../context/ToastContext";

// function Icon({ id, open }) {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       fill="none"
//       viewBox="0 0 24 24"
//       strokeWidth={2}
//       stroke="currentColor"
//       className={`${
//         id === open ? "rotate-180" : ""
//       } h-5 w-5 transition-transform`}
//     >
//       <path
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         d="M19.5 8.25l-7.5 7.5-7.5-7.5"
//       />
//     </svg>
//   );
// }

// const AddQSet = () => {
//   const navigate = useNavigate();

//   const {
//     control,
//     register,
//     reset,
//     handleSubmit,
//     setValue,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {
//       title: "",
//       alias: "",
//       course: "",
//       stream: "",
//       questions: "",
//       marks: "",
//       duration: "",
//       subject: "",
//       faculty: "",
//     },
//   });

//   const [loading, setLoading] = useState(false);
//   const [courses, setCourses] = useState([]);
//   const [streams, setStreams] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [faculty, setFaculty] = useState([]);
//   const [subjectLoading, setSubjectLoading] = useState(false);
//   const [facultyLoading, setFacultyLoading] = useState(false);
//   const [open, setOpen] = useState(0);

//   const { showSuccess, showError } = useToast();

//   const selectedCourse = useWatch({
//     control,
//     name: "course",
//   });

//   const selectedStream = useWatch({
//     control,
//     name: "stream",
//   });

//   const handleOpen = (value) => setOpen(open === value ? 0 : value);

//   const getArray = (result) => {
//     if (Array.isArray(result)) return result;
//     if (Array.isArray(result?.data)) return result.data;
//     if (Array.isArray(result?.result)) return result.result;
//     return [];
//   };

//   async function handleSubmitCustom(data) {
//     setLoading(true);

//     const formData = new FormData();

//     formData.append("title", data.title);
//     formData.append("alias", data.alias);
//     formData.append("course", data.course);
//     formData.append("stream", data.stream);
//     formData.append("totalQuestions", data.questions);
//     formData.append("totalMarks", data.marks);
//     formData.append("duration", data.duration);

//     if (data.faculty) formData.append("faculty", data.faculty);
//     if (data.subject) formData.append("subject", data.subject);

//     const obj = {
//       quesStatus: "Not Uploaded",
//       solStatus: "Not Uploaded",
//     };

//     formData.append("aiObj", JSON.stringify(obj));

//     try {
//       const rp = await apiService.request("/i/ims/aiqset", {
//         method: "POST",
//         body: formData,
//       });

//       console.log(rp);

//       setLoading(false);
//       reset();
//       setSubjects([]);
//       setFaculty([]);

//       showSuccess("QSet created!!");
//     } catch (err) {
//       setLoading(false);
//       console.log(err);
//       showError("Request failed");
//     }
//   }

//   useEffect(() => {
//     const courseQuery = new URLSearchParams({
//       option: "COURSE",
//       limit: "all",
//       sort: "seq ASC",
//     }).toString();

//     const streamQuery = new URLSearchParams({
//       option: "STREAM",
//       limit: "all",
//       sort: "seq ASC",
//     }).toString();

//     apiService
//       .request_old(`/i/admin/coption?${courseQuery}`, {
//         method: "GET",
//       })
//       .then((result) => {
//         setCourses(getArray(result));
//       })
//       .catch((err) => {
//         console.log(err);
//         setCourses([]);
//       });

//     apiService
//       .request_old(`/i/admin/coption?${streamQuery}`, {
//         method: "GET",
//       })
//       .then((result) => {
//         setStreams(getArray(result));
//       })
//       .catch((err) => {
//         console.log(err);
//         setStreams([]);
//       });
//   }, []);
//   useEffect(() => {
//     let isActive = true;

//     setFaculty([]);
//     setValue("faculty", "");

//     const params = new URLSearchParams();

//     if (selectedCourse) {
//       params.append("course", selectedCourse);
//     }

//     params.append("limit", "all");

//     const facultyUrl = `/admin/faculty?${params.toString()}`;

//     setFacultyLoading(true);

//     apiService
//       .abc_request(facultyUrl, {
//         method: "GET",
//       })
//       .then((result) => {
//         if (!isActive) return;
//         setFaculty(getArray(result));
//       })
//       .catch((err) => {
//         if (!isActive) return;
//         console.log(err);
//         setFaculty([]);
//       })
//       .finally(() => {
//         if (!isActive) return;
//         setFacultyLoading(false);
//       });

//     return () => {
//       isActive = false;
//     };
//   }, [selectedCourse, setValue]);
//   useEffect(() => {
//     let isActive = true;

//     setSubjects([]);
//     setValue("subject", "");

//     const params = new URLSearchParams();

//     if (selectedCourse) {
//       params.append("course", selectedCourse);
//     }

//     if (selectedStream) {
//       params.append("stream", selectedStream);
//     }

//     params.append("limit", "all");

//     const queryString = params.toString();

//     const subjectUrl = queryString
//       ? `/i/ims/subject?${queryString}`
//       : `/i/ims/subject`;

//     setSubjectLoading(true);

//     apiService
//       .request_old(subjectUrl, {
//         method: "GET",
//       })
//       .then((result) => {
//         if (!isActive) return;
//         setSubjects(getArray(result));
//       })
//       .catch((err) => {
//         if (!isActive) return;
//         console.log(err);
//         setSubjects([]);
//       })
//       .finally(() => {
//         if (!isActive) return;
//         setSubjectLoading(false);
//       });

//     return () => {
//       isActive = false;
//     };
//   }, [selectedCourse, selectedStream, setValue]);
//   return (
//     <div className="p-4">
//       <div className="flex justify-between items-center mb-6">
//         <h1 className="text-2xl font-bold">Add New Question Set</h1>

//         <Button
//           onClick={() => navigate("/tools/qSet")}
//           variant="light"
//           size="sm"
//           icon={FaArrowLeft}
//         >
//           Back to List
//         </Button>
//       </div>

//       <div className="flex items-center text-sm mb-6">
//         <span className="text-gray-500">Home</span>
//         <span className="mx-2">/</span>
//         <span onClick={() => navigate("/tools/qSet")} className="text-gray-500">
//           QSet
//         </span>
//         <span className="mx-2">/</span>
//         <span className="text-blue-600">New</span>
//       </div>

//       <div className="bg-white rounded-lg shadow-md overflow-visible mb-6 relative z-10">
//         <div className="p-2 overflow-visible">
//           <div>
//             <form onSubmit={handleSubmit(handleSubmitCustom)}>
//               <div className="flex flex-col justify-around overflow-visible">
//                 <div className="flex ml-5 mr-5">
//                   <div className="p-3 w-1/2">
//                     <label className="block text-gray-700 mb-2">
//                       Title <span className="text-red-500">*</span>
//                     </label>

//                     <input
//                       type="text"
//                       placeholder="Title of qSet"
//                       className="w-full border rounded px-3 py-2"
//                       {...register("title", { required: "Title is required" })}
//                     />

//                     {errors.title && (
//                       <p className="text-red-500 text-sm">
//                         {errors.title.message}
//                       </p>
//                     )}
//                   </div>

//                   <div className="p-3 w-1/2">
//                     <label className="block text-gray-700 mb-2">
//                       Alias <span className="text-red-500">*</span>
//                     </label>

//                     <input
//                       type="text"
//                       placeholder="Title Alias of qSet"
//                       className="w-full border rounded px-3 py-2"
//                       {...register("alias", { required: "Alias is required" })}
//                     />

//                     {errors.alias && (
//                       <p className="text-red-500 text-sm">
//                         {errors.alias.message}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="flex ml-5 mr-5">
//                   <div className="p-3 w-1/2 overflow-visible">
//                     <label className="block text-gray-700 mb-2">
//                       Course <span className="text-red-500">*</span>
//                     </label>

//                     <Controller
//                       name="course"
//                       control={control}
//                       rules={{ required: "Course is required" }}
//                       render={({ field }) => (
//                         <Select
//                           key={field.value || "course"}
//                           variant="outlined"
//                           label="Select Course"
//                           value={field.value || ""}
//                           onChange={(val) => {
//                             field.onChange(val || "");
//                           }}
//                           className="z-[9999]"
//                           menuProps={{
//                             className: "z-[9999] max-h-60 overflow-auto",
//                           }}
//                         >
//                           {courses?.map((course, i) => (
//                             <Option
//                               key={course.id || course._id || i}
//                               value={course.id || course._id}
//                             >
//                               {course.value || course.name || course.title}
//                             </Option>
//                           ))}
//                         </Select>
//                       )}
//                     />

//                     {errors.course && (
//                       <p className="text-red-500 text-sm">
//                         {errors.course.message}
//                       </p>
//                     )}
//                   </div>

//                   <div className="p-3 w-1/2 overflow-visible">
//                     <label className="block text-gray-700 mb-2">
//                       Stream <span className="text-red-500">*</span>
//                     </label>

//                     <Controller
//                       name="stream"
//                       control={control}
//                       rules={{ required: "Stream is required" }}
//                       render={({ field }) => (
//                         <Select
//                           key={field.value || "stream"}
//                           variant="outlined"
//                           label="Select Stream"
//                           value={field.value || ""}
//                           onChange={(val) => {
//                             field.onChange(val || "");
//                           }}
//                           className="z-[9999]"
//                           menuProps={{
//                             className: "z-[9999] max-h-60 overflow-auto",
//                           }}
//                         >
//                           {streams?.map((stream, i) => (
//                             <Option
//                               key={stream.id || stream._id || i}
//                               value={stream.id || stream._id}
//                             >
//                               {stream.value || stream.name || stream.title}
//                             </Option>
//                           ))}
//                         </Select>
//                       )}
//                     />

//                     {errors.stream && (
//                       <p className="text-red-500 text-sm">
//                         {errors.stream.message}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="flex ml-5 mr-5">
//                   <div className="p-3 w-1/2">
//                     <label className="block text-gray-700 mb-2">
//                       Total Questions <span className="text-red-500">*</span>
//                     </label>

//                     <input
//                       type="number"
//                       placeholder="Total Questions"
//                       className="w-full border rounded px-3 py-2"
//                       {...register("questions", {
//                         required: "Total Questions is required",
//                       })}
//                     />

//                     {errors.questions && (
//                       <p className="text-red-500 text-sm">
//                         {errors.questions.message}
//                       </p>
//                     )}
//                   </div>

//                   <div className="p-3 w-1/2">
//                     <label className="block text-gray-700 mb-2">
//                       Total Marks <span className="text-red-500">*</span>
//                     </label>

//                     <input
//                       type="number"
//                       placeholder="Total Marks"
//                       className="w-full border rounded px-3 py-2"
//                       {...register("marks", {
//                         required: "Total Marks is required",
//                       })}
//                     />

//                     {errors.marks && (
//                       <p className="text-red-500 text-sm">
//                         {errors.marks.message}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="flex ml-5 mr-5">
//                   <div className="p-3 w-1/2">
//                     <label className="block text-gray-700 mb-2">
//                       Duration (in mins) <span className="text-red-500">*</span>
//                     </label>

//                     <input
//                       type="number"
//                       placeholder="Enter Duration in mins"
//                       className="w-full border rounded px-3 py-2"
//                       {...register("duration", {
//                         required: "Duration is required",
//                       })}
//                     />

//                     {errors.duration && (
//                       <p className="text-red-500 text-sm">
//                         {errors.duration.message}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="ml-5 mr-10 p-3">
//                   <Accordion
//                     open={open === 1}
//                     icon={<Icon id={1} open={open} />}
//                   >
//                     <AccordionHeader onClick={() => handleOpen(1)}>
//                       Advance Settings
//                     </AccordionHeader>

//                     <AccordionBody>
//                       <div className="flex ml-5 mr-5">
//                         <div className="p-3 w-1/2">
//                           <label className="block text-gray-700 mb-2">
//                             Subject
//                           </label>

//                           <Controller
//                             name="subject"
//                             control={control}
//                             render={({ field }) => (
//                               <select
//                                 value={field.value || ""}
//                                 disabled={!selectedCourse || subjectLoading}
//                                 onChange={(e) =>
//                                   field.onChange(e.target.value || "")
//                                 }
//                                 className="w-full border border-blue-gray-200 rounded-md px-3 py-2 text-gray-700 outline-none focus:border-gray-900 bg-white disabled:bg-gray-100"
//                               >
//                                 <option value="">
//                                   {subjectLoading
//                                     ? "Loading Subject..."
//                                     : "Select Subject"}
//                                 </option>

//                                 {subjects?.map((subject, i) => (
//                                   <option
//                                     key={subject.id || subject._id || i}
//                                     value={subject.id || subject._id}
//                                   >
//                                     {subject.name ||
//                                       subject.value ||
//                                       subject.title}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}
//                           />

//                           {errors.subject && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {errors.subject.message}
//                             </p>
//                           )}
//                         </div>

//                         <div className="p-3 w-1/2">
//                           <label className="block text-gray-700 mb-2">
//                             Faculty
//                           </label>

//                           <Controller
//                             name="faculty"
//                             control={control}
//                             render={({ field }) => (
//                               <select
//                                 value={field.value || ""}
//                                 disabled={facultyLoading}
//                                 onChange={(e) =>
//                                   field.onChange(e.target.value || "")
//                                 }
//                                 className="w-full border border-blue-gray-200 rounded-md px-3 py-2 text-gray-700 outline-none focus:border-gray-900 bg-white disabled:bg-gray-100"
//                               >
//                                 <option value="">
//                                   {facultyLoading
//                                     ? "Loading Faculty..."
//                                     : "Select Faculty"}
//                                 </option>

//                                 {faculty?.map((item, i) => (
//                                   <option
//                                     key={item.id || item._id || i}
//                                     value={item.id || item._id}
//                                   >
//                                     {item.name || item.value || item.title}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}
//                           />

//                           {errors.faculty && (
//                             <p className="text-red-500 text-sm mt-1">
//                               {errors.faculty.message}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                     </AccordionBody>
//                   </Accordion>
//                 </div>

//                 <div className="p-3">
//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="bg-green-500 font-thin text-white p-2 rounded hover:bg-green-600 m-2 disabled:opacity-60"
//                   >
//                     Submit
//                   </button>

//                   {loading && <Loader />}
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>

//       <div className="mt-6 bg-gray-50 border rounded-lg p-4">
//         <h3 className="font-semibold mb-2">Instructions:</h3>

//         <ul className="list-disc pl-5">
//           <li>
//             Fields marked with <span className="text-red-500">*</span> are
//             mandatory.
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default AddQSet;
